module.exports = __webpack_public_path__ + "img/ÖEL.7734207c.svg";